
if (!customElements.get('fw-team-carousel')) {
  customElements.define('fw-team-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-team-track]');
      if (!this.track) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.direction = 1;
      this.position = this.track.scrollLeft;
      this.paused = false;
      const pauseButton = this.querySelector('[data-team-pause]');
      const pauseText = pauseButton?.textContent.trim() || 'Pause auto-scroll';
      const updatePause = () => { if (pauseButton) { pauseButton.setAttribute('aria-pressed', String(this.paused)); pauseButton.textContent = this.paused ? pauseText.replace(/^Pause/i, 'Play') : pauseText; } };
      this.hovered = false;
      this.until = 0;
      const delay = () => { this.until = performance.now() + 5000; this.position = this.track.scrollLeft; };
      const pause = () => {
        this.paused = true;
        updatePause();
      };
      this.track.addEventListener('pointerdown', pause, options);
      this.track.addEventListener('wheel', pause, options);
      this.track.addEventListener('keydown', e => { if (['ArrowLeft', 'ArrowRight', 'Home', 'End', 'PageUp', 'PageDown'].includes(e.key)) pause(); }, options);
      this.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') this.hovered = true; }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; }, options);
      this.addEventListener('pointerdown', delay, options);
      this.addEventListener('pointerup', delay, options);
      this.addEventListener('wheel', delay, options);
      this.addEventListener('keydown', delay, options);
      this.track.addEventListener('scroll', () => { if (this.paused || performance.now() < this.until) this.position = this.track.scrollLeft; }, options);
      this.querySelector('[data-team-pause]')?.addEventListener('click', e => {
        this.paused = !this.paused;
        this.until = 0;
        this.position = this.track.scrollLeft;
        updatePause();
      }, options);
      const step = direction => {
        pause();
        delay();
        const card = this.track.querySelector('.fw-team__card');
        if (card) this.track.scrollBy({left: direction * (card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap)), behavior: this.motion.matches ? 'instant' : 'smooth'});
      };
      this.querySelector('[data-team-prev]')?.addEventListener('click', () => step(-1), options);
      this.querySelector('[data-team-next]')?.addEventListener('click', () => step(1), options);
      this.addEventListener('shopify:block:select', e => {
        this.until = Infinity;
        e.target.scrollIntoView({block:'nearest', inline:'center'});
      }, options);
      this.addEventListener('shopify:block:deselect', () => { this.until = 0; }, options);
      const tick = now => {
        const dt = Math.min((now - (this.last || now)) / 1000, .05);
        this.last = now;
        const max = this.track.scrollWidth - this.track.clientWidth;
        const focused = this.contains(document.activeElement);
        const active = this.dataset.autoplay === 'true' && !this.motion.matches && !window.Shopify?.designMode && !document.hidden && !document.querySelector('.fw-profile[open]') && !this.paused && !this.hovered && !focused && now > this.until && max > 1;
        if (active) {
          this.position += this.direction * 24 * dt;
          if (this.position >= max) { this.position = max; this.direction = -1; }
          if (this.position <= 0) { this.position = 0; this.direction = 1; }
          this.track.scrollLeft = this.position;
        } else this.position = this.track.scrollLeft;
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }
    disconnectedCallback() { cancelAnimationFrame(this.frame); this.controller?.abort(); }
  });
}


if (!window.faunwalkProfilesReady) {
 window.faunwalkProfilesReady = true;
 document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const dialog = document.querySelector('.fw-profile[open]');
  if (dialog) { event.preventDefault(); event.stopPropagation(); dialog.close(); }
 }, true);
 document.addEventListener('click', event => {
  const trigger = event.target.closest('[data-profile-open]');
  if (trigger) {
   const dialog = document.getElementById(trigger.dataset.profileOpen);
   if (!dialog) return;
   dialog.profileTrigger = trigger;
   dialog.showModal();
   document.documentElement.classList.add('fw-profile-open');
   dialog.addEventListener('close', () => {
    if (!document.querySelector('.fw-profile[open]')) document.documentElement.classList.remove('fw-profile-open');
    if (dialog.profileTrigger?.isConnected) dialog.profileTrigger.focus({preventScroll:true});
   }, {once:true});
   return;
  }
  const closeButton = event.target.closest('[data-profile-close]');
  if (closeButton) closeButton.closest('dialog').close();
  if (event.target.matches('dialog.fw-profile')) {
   const r = event.target.getBoundingClientRect();
   if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) event.target.close();
  }
 });
 document.addEventListener('shopify:section:unload', () => {
  if (!document.querySelector('.fw-profile[open]')) document.documentElement.classList.remove('fw-profile-open');
 });
}
